// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t66NF","clinicsSelect":"styles_clinicsSelect__1-9r8"};